import ApiRoutes from "../../../constants/api-routes";
import ntbInstance from "../../../config/axios/axios-instance";
import store from "../../../store/store";
import consoleReducer from "../redux/console.reducer";
import { getErrorMessage, showNotification } from "../../../helpers/notification-helper";
import Types from "../../../constants/types";

export const getDsoDataByCif = async (refNo, cif) => {
  try {
    const response = await ntbInstance.get(
      `${ApiRoutes.GET_DSO_DATA_BY_CIF}?refNo=${refNo ? refNo : ""}&cif=${cif ? cif : ""}`,
    );
    if (response.data.ResponseCode === Types.API_SUCCESS_CODE) {
      store.dispatch(
        consoleReducer.actions.setExistingCusDetails({
          customer: response.data.RequestCustomer.find(
            (item) => item.Persontypeid === store.getState().loginReducer.personTypeId,
          ),
          customers: response.data.RequestCustomer,
          profile: response.data?.RequestProfile,
          product: response.data?.RequestProduct,
          vas: response.data?.RequestVas[0],
          kyc: response.data?.Kyc,
          lendingEmp: response.data?.RequestLendingEmp[0] ?? null,
          lendingPersonal: response.data?.RequestLendingPersonal[0] ?? null,
          relative: response.data?.RequestRelative[0] ?? null,
          spouse: response.data?.RequestSpouse[0] ?? null,
          termAndCondition: response.data?.RequestTC ?? null,
        }),
      );
      return response.data;
    } else if (response.data.ResponseCode === Types.API_FAILED_CODE) {
      showNotification("ERROR", response.data.ResponseFrendlyMessage);
    }
  } catch (e) {
    throw new Error("API Error");
  }
};

export const tableDataModifierApi = async (body, isExistingCusDetailsAPICall) => {
  try {
    const response = await ntbInstance.post(`${ApiRoutes.TABLE_DATA_MODIFIER_API}`, body);
    if (response.data.ResponseCode === Types.API_SUCCESS_CODE) {
      if (isExistingCusDetailsAPICall) {
        await getDsoDataByCif(store.getState().loginReducer.requestId, store.getState().loginReducer.cifNo);
      }
      return response.data;
    } else if (response.data.ResponseCode === Types.API_FAILED_CODE) {
      showNotification("ERROR", response.data.ResponseFrendlyMessage);
    }
  } catch (e) {
    showNotification("ERROR", getErrorMessage(e));
    throw new Error();
  }
};

export const saveKyc = async (body) => {
  try {
    const response = await ntbInstance.post(`${ApiRoutes.SAVE_KYC}`, body);
    if (response.data.ResponseCode === Types.API_SUCCESS_CODE) {
      await getDsoDataByCif(store.getState().loginReducer.requestId, store.getState().loginReducer.cifNo);
    } else if (response.data.ResponseCode === Types.API_FAILED_CODE) {
      showNotification("ERROR", response.data.ResponseFrendlyMessage);
    }
  } catch (e) {
    showNotification("ERROR", getErrorMessage(e));
    throw new Error();
  }
};

export const getRequiredDocsByMandate = async (params) => {
  try {
    const response = await ntbInstance.get(`${ApiRoutes.GET_REQUIRED_DOCS_BY_MANDATE}`, { params: params });
    if (response.data.ResponseCode === Types.API_SUCCESS_CODE) {
      store.dispatch(consoleReducer.actions.setMandateDos(response.data.Output));
      return response.data;
    } else if (response.data.ResponseCode === Types.API_FAILED_CODE) {
      showNotification("ERROR", response.data.ResponseFrendlyMessage);
    }
  } catch (e) {
    showNotification("ERROR", getErrorMessage(e));
    throw new Error();
  }
};

export const getKyc = async (mandateId) => {
  try {
    const response = await ntbInstance.get(`${ApiRoutes.Get_KYC}?mandateId=${mandateId}`);
    if (response.data.ResponseCode === Types.API_SUCCESS_CODE) {
      return response.data;
    } else if (response.data.ResponseCode === Types.API_FAILED_CODE) {
      showNotification("ERROR", response.data.ResponseFrendlyMessage);
    }
  } catch (e) {
    showNotification("ERROR", getErrorMessage(e));
    throw new Error();
  }
};

export const fixedDropDownListRequest = async (id) => {
  try {
    const response = await ntbInstance.get(`${ApiRoutes.FIXED_DROP_DOWN_LIST_REQUEST}?dropDownId=${id}`);
    if (response.data.ResponseCode === Types.API_SUCCESS_CODE) {
      return response.data;
    } else if (response.data.ResponseCode === Types.API_FAILED_CODE) {
      showNotification("ERROR", response.data.ResponseFrendlyMessage);
    }
  } catch (e) {
    showNotification("ERROR", getErrorMessage(e));
    throw new Error();
  }
};

export const getOccupation = async (statusCategory) => {
  try {
    const response = await ntbInstance.get(`${ApiRoutes.GET_OCCUPATION}?StatusCategory=${statusCategory}`);
    if (response.data.ResponseCode === Types.API_SUCCESS_CODE) {
      return response.data;
    } else if (response.data.ResponseCode === Types.API_FAILED_CODE) {
      showNotification("ERROR", response.data.ResponseFrendlyMessage);
    }
  } catch (e) {
    showNotification("ERROR", getErrorMessage(e));
    throw new Error();
  }
};

export const getCompanyDetails = async (companyName) => {
  try {
    const response = await ntbInstance.get(`${ApiRoutes.GET_COMPANY_DETAILS}?companyCode=0&CompanyName=${companyName}`);
    if (response.data.ResponseCode === Types.API_SUCCESS_CODE) {
      return response.data;
    } else if (response.data.ResponseCode === Types.API_FAILED_CODE) {
      showNotification("ERROR", response.data.ResponseFrendlyMessage);
    }
  } catch (e) {
    showNotification("ERROR", getErrorMessage(e));
    throw new Error();
  }
};

export const getDesignation = async (designationName) => {
  try {
    const response = await ntbInstance.get(`${ApiRoutes.GET_DESIGNATION}?designationName=${designationName}`);
    if (response.data.ResponseCode === Types.API_SUCCESS_CODE) {
      return response.data;
    } else if (response.data.ResponseCode === Types.API_FAILED_CODE) {
      showNotification("ERROR", response.data.ResponseFrendlyMessage);
    }
  } catch (e) {
    showNotification("ERROR", getErrorMessage(e));
    throw new Error();
  }
};

export const deleteDocument = async (body) => {
  try {
    const response = await ntbInstance.post(ApiRoutes.DEL_DOCUMENT, body);
    if (response.data.ResponseCode === Types.API_SUCCESS_CODE) {
      return response.data;
    } else if (response.data.ResponseCode === Types.API_FAILED_CODE) {
      showNotification("ERROR", response.data.ResponseFrendlyMessage);
    }
  } catch (e) {
    showNotification("ERROR", getErrorMessage(e));
    throw new Error();
  }
};

export const addDocument = async (body) => {
  try {
    const response = await ntbInstance.post(ApiRoutes.ADD_DOCUMENT, body);
    if (response.data.ResponseCode === Types.API_SUCCESS_CODE) {
      // await getDsoDataByCif(store.getState().loginReducer.requestId, store.getState().loginReducer.cifNo);
      return response.data;
    } else if (response.data.ResponseCode === Types.API_FAILED_CODE) {
      showNotification("ERROR", response.data.ResponseFrendlyMessage);
    }
  } catch (e) {
    showNotification("ERROR", getErrorMessage(e));
    throw new Error();
  }
};

export const dsoSubmit = async (body) => {
  try {
    const response = await ntbInstance.post(`${ApiRoutes.DSO_SUBMIT}`, body);
    if (response.data.ResponseCode === Types.API_SUCCESS_CODE) {
      return response.data;
    } else if (response.data.ResponseCode === Types.API_FAILED_CODE) {
      showNotification("ERROR", response.data.ResponseFrendlyMessage);
    }
  } catch (e) {
    showNotification("ERROR", getErrorMessage(e));
    throw new Error();
  }
};

export const getCityProvinceData = async (city) => {
  try {
    const response = await ntbInstance.get(`${ApiRoutes.GET_CITY_PROVINCE_DATA}?City=${city}`);
    if (response.data.ResponseCode === Types.API_SUCCESS_CODE) {
      return response.data;
    } else if (response.data.ResponseCode === Types.API_FAILED_CODE) {
      showNotification("ERROR", response.data.ResponseFrendlyMessage);
    }
  } catch (e) {
    throw new Error("API Error");
  }
};

export const getExistingCards = async (params) => {
  try {
    const response = await ntbInstance.get(`${ApiRoutes.GET_EXISTING_CARDS}`, { params: params });
    if (response.data.ResponseCode === Types.API_SUCCESS_CODE) {
      return response.data;
    } else if (response.data.ResponseCode === Types.API_FAILED_CODE) {
      showNotification("ERROR", response.data.ResponseFrendlyMessage);
    }
  } catch (e) {
    throw new Error("API Error");
  }
};

export const getExistingCustomerDataSummaryByCif = async () => {
  try {
    const response = await ntbInstance.get(`${ApiRoutes.GET_EXISTING_CUSTOMER_DATA_SUMMARY_BY_CIF}`, {
      params: { cif: store.getState().loginReducer.cifNo },
    });
    if (response.data.ResponseCode === Types.API_SUCCESS_CODE) {
      return response.data;
    }
  } catch (e) {
    throw new Error("API Error");
  }
};

export const getDocumentsByClassFilter = async (body) => {
  try {
    const response = await ntbInstance.post(`${ApiRoutes.GET_DOCUMENTS_BY_CLASS_FILTER}`, body);
    if (response.data.ResponseCode === Types.API_SUCCESS_CODE) {
      return response.data;
    }
  } catch (e) {
    throw new Error("API Error");
  }
};

export const getFileContent = async (body) => {
  try {
    const response = await ntbInstance.get(`${ApiRoutes.GET_FILE_CONTENT}`, {
      params: body,
    });
    if (response.data.ResponseCode === Types.API_SUCCESS_CODE) {
      return response.data;
    }
  } catch (e) {
    throw new Error("API Error");
  }
};

export const getCribScoreV2 = async (body) => {
  try {
    const response = await ntbInstance.post(`${ApiRoutes.GET_CRIB_SCORE_V2}`, body);
    return response.data;
  } catch (e) {
    throw new Error("API Error");
  }
};

export const clearProduct = async (body) => {
  try {
    const response = await ntbInstance.post(`${ApiRoutes.CLEAR_PRODUCT}`, body);
    return response.data;
  } catch (e) {
    throw new Error("API Error");
  }
};
